import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from '@/store/index'

// 路由重复导致的报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      base: 'home',
      // component: () => import(/* webpackChunkName: "Login" */ './views/Login/index.vue'),
      redirect: '/repos',
      children: [
        {
          path: '/trend',
          name: 'trend',
          component: () => import(/* webpackChunkName: "trendPanel" */ './views/Trend.vue'),
        },
        {
          path: '/repos',
          name: 'repos',
          component: () => import(/* webpackChunkName: "reposPanel" */ './views/Repos.vue'),
        },
        {
          name: 'icon',
          path: 'icon',
          component: () => import(/* webpackChunkName: "iconPanel" */ './views/Icon.vue'),
        },
        {
          name: 'setting',
          path: 'setting',
          component: () => import(/* webpackChunkName: "setting" */ './views/Setting.vue'),
        },
        {
          name: 'email',
          path: 'email',
          component: () => import(/* webpackChunkName: "emailSetting" */ './views/EmailPanel.vue'),
        },
        {
          name: 'about',
          path: 'about',
          component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
        },
        {
          name: 'profile',
          path: 'profile',
          component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
        },
        {
          name: 'subscribe',
          path: 'subscribe',
          component: () => import(/* webpackChunkName: "subscribe" */ './views/Subscribe.vue'),
        },
        {
          name: 'feedback',
          path: 'feedback',
          component: () => import(/* webpackChunkName: "feedback" */ './views/Feedback.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Login" */ './views/Login/index.vue'),
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const vm = router.app
  // 每次初次加载，获取用户信息
  if (!vm._isMounted) {
    store.dispatch('user/getUserInfo').then((user) => {
      if (!user) {
        next({
          name: 'login',
          replace: true,
        })
      } else if (to.name === 'login') {
        next({
          name: 'home',
          replace: true,
        })
      } else {
        next()
      }
    }).catch(() => {
      next({
        name: 'login',
        replace: true,
      })
    })
  } else {
    next()
  }
})

export default router
